module.exports = __webpack_public_path__ + "static/icon-big-nausea.3f3db0d9.svg";